import React, { useState, useEffect } from "react";
import { format, subMonths } from "date-fns";
import API from "../../services/api";
import { toLakhs,getBrandOptions } from "../../utils/constants";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import * as XLSX from "xlsx";
import { SlSelect, SlOption,SlIcon } from "@shoelace-style/shoelace/dist/react";
import ScrollContainer from "react-indiana-drag-scroll";
function AccountConversionRollingAverage() {
  const [newsPapers, setNewsPapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [loader, setLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [data, setData] = useState([{}]);
  const [selectedType, setSelectedType] = useState("all");
  let currDate = new Date().setDate(1);
  let prevDate = subMonths(currDate, 11);
  let monthArray = [];
  for (let i = 0; i < 12; i++) {
    let start = format(prevDate, "MMMyy");
    let end = format(currDate, "MMMyy");
    currDate = subMonths(currDate, 1);
    prevDate = subMonths(prevDate, 1);
    monthArray.push(`${start}-${end}`);
  }
  monthArray.reverse();
  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewsPapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchData = async () => {
    try {
      setLoader(true);
      let res = await API({
        url: "/monthly/account-conversion-rolling-average",
        method: "POST",
        responseType: "json",
        data: {
          newsPaper: selectedNewspaper,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchNewsPapers();
  }, []);

  const getdownloadData = ()=>{
    try {
      setDownloadLoader(true)
      const worksheetData = [];

  // Add Headers
  worksheetData.push(["Revenues in Lakhs", ...monthArray]);

  // Add Row Data
  worksheetData.push(["Total Deployed Accounts", ...monthArray.map((item) => data["deployedAccounts"]?.[item]?.unique_brands || 0)]);

  worksheetData.push(["W2N"]);
  worksheetData.push(["Accounts Advertised", ...monthArray.map((item) => data["way2newsData"]?.[item]?.unique_brands || 0)]);
  worksheetData.push(["No. of Insertions", ...monthArray.map((item) => data["way2newsData"]?.[item]?.total_count || 0)]);
  worksheetData.push(["Revenues", ...monthArray.map((item) => data["way2newsData"]?.[item]?.total_amount || 0)]);

  worksheetData.push([selectedNewspaper]);
  worksheetData.push(["Accounts Advertised", ...monthArray.map((item) => data["newsPaperData"]?.[item]?.unique_brands || 0)]);
  worksheetData.push(["No. of Insertions", ...monthArray.map((item) => data["newsPaperData"]?.[item]?.total_count || 0)]);
  worksheetData.push(["Revenues", ...monthArray.map((item) => data["newsPaperData"]?.[item]?.total_amount || 0)]);

  worksheetData.push(["Missing in W2N vs Eenadu"]);
  worksheetData.push(["No of Accounts", ...monthArray.map((item) => data["missedData"]?.[item]?.count || 0)]);
  worksheetData.push(["Likely to convert in next 3 months", ...monthArray.map((item) => data["missedData"]?.[item]?.likelyToConvert || 0)]);
  worksheetData.push(["Physically met in last 1 month", ...monthArray.map((item) => data["missedData"]?.[item]?.brands_physical_last_month || 0)]);
  worksheetData.push(["Physically met in last 3 months", ...monthArray.map((item) => data["missedData"]?.[item]?.brands_physical_last_3_months || 0)]);

  // worksheetData.push(["Missing in W2N and Eenadu"]);
  // worksheetData.push(["Accounts Advertised", ...monthArray.map((item) => data["newsPaperData"]?.[item]?.missing_brands_count || 0)]);
  // worksheetData.push(["Have potential", ...monthArray.map((item) => data["newsPaperData"]?.[item]?.potential || 0)]);
  // worksheetData.push(["No potential", ...monthArray.map((item) => data["newsPaperData"]?.[item]?.no_potential || 0)]);

  // Convert to XLSX
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "AccountConversion Rolling Average");
  XLSX.writeFile(workbook, `AccountConversionRollingAverage.xlsx`);

    } catch (error) {
      console.error(error, "Error downloading account conversion rolling average");
    }
    finally{
      setDownloadLoader(false); 
    }
  }

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper,selectedType]);

  return (
    <>
      <aside className="flex justify-end md:justify-between w-full my-2">
        <h5 className="hidden md:inline">12 Months Rolling Average</h5>
      <div className="flex items-center gap-2 justify-end ml-auto">
      <SlSelect size="small" value={selectedType} label="Team"  onSlChange={(e) => {setSelectedType(e.target.value)}}>
      {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect
        className="max-w-sm"
          onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          value={selectedNewspaper}
          size="small"
          label="Newspaper"
        >
          {newsPapers.map((item) => (
            <SlOption value={item?.name}>{item?.name}</SlOption>
          ))}
        </SlSelect>
        {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
          </div>
      </aside>
      <ScrollContainer>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Revenues in Lakhs</th>
            {monthArray.map((item) => (
              <th>{item}</th>
            ))}
          </tr>
        </thead>
        {!loader && Object.keys(data)?.length > 0 ? (
          <tbody>
            <tr>
              <th>Total Deployed Accounts</th>
              {monthArray.map((item) => (
                <td>{data["deployedAccounts"]?.[item]?.unique_brands}</td>
              ))}
            </tr>
            <tr>
              <th colSpan={13}>W2N</th>
            </tr>
            <tr>
              <td>Accounts Advertised</td>
              {monthArray.map((item) => (
                <td>{data["way2newsData"]?.[item]?.unique_brands}</td>
              ))}
            </tr>
            <tr>
              <td>No. of Insertions</td>
              {monthArray.map((item) => (
                <td>{data["way2newsData"]?.[item]?.total_count}</td>
              ))}
            </tr>
            <tr>
              <td>
                <td>Revenues</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {toLakhs(data["way2newsData"]?.[item]?.total_amount || 0)}
                </td>
              ))}
            </tr>
            <tr>
              <th colSpan={13}>{selectedNewspaper}</th>
            </tr>
            <tr>
              <td>Accounts Advertised</td>
              {monthArray.map((item) => (
                <td>{data["newsPaperData"]?.[item]?.unique_brands}</td>
              ))}
            </tr>
            <tr>
              <td>No. of Insertions</td>
              {monthArray.map((item) => (
                <td>{data["newsPaperData"]?.[item]?.total_count || 0}</td>
              ))}
              
            </tr>
            <tr>
              <td>
                <td>Revenues</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {toLakhs(data["newsPaperData"]?.[item]?.total_amount || 0)}
                </td>
              ))}
              
            </tr>
            <tr>
              <th colSpan={13}>Missing in W2N vs Eenadu</th>
            </tr>
            <tr>
              <td>
                <td>No of Accounts</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {(data["missedData"]?.[item]?.count || 0)}
                </td>
              ))}
            </tr>
            <tr>
              <td>
                <td>Likely to convert in next 3 months</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {(data["missedData"]?.[item]?.likelyToConvert || 0)}
                </td>
              ))}
            </tr>
            <tr>
              <td>
                <td>Physically met in last 1 month</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {(data["missedData"]?.[item]?.brands_physical_last_month || 0)}
                </td>
              ))}
            </tr>
            <tr>
              <td>
                <td>Physically met in last 3 months</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {data["missedData"]?.[item]?.brands_physical_last_3_months || 0}
                </td>
              ))}
            </tr>
            {/* <tr>
              <th colSpan={13}>Missing in W2N and Eenadu</th>
            </tr>
            <tr>
              <td>Accounts Advertised</td>
              {monthArray.map((item) => (
                <td>{data["newsPaperData"]?.[item]?.missing_brands_count}</td>
              ))}
            </tr>
            <tr>
              <td>
                <td>Have potential </td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {toLakhs(data["newsPaperData"]?.[item]?.potential || 0)}
                </td>
              ))}
            </tr>{" "}
            <tr>
              <td>
                <td>No potential</td>
              </td>
              {monthArray.map((item) => (
                <td>
                  {toLakhs(data["newsPaperData"]?.[item]?.no_potential || 0)}
                </td>
              ))}
            </tr> */}
          </tbody>
        ) : loader ? (
          <TableLoader colspan={14} />
        ) : (
          <NoDataFound colspan={14} />
        )}
      </table>
      </ScrollContainer>
    </>
  );
}

export default AccountConversionRollingAverage;
